// Complete Employee Data with Candidate Fields Integration
export const employeesData = [
  {
    id: 1,
    // Data Pribadi (Personal Data) - Complete with candidate fields
    personalData: {
      employee_id: 12,
      employee_code: "P0740",
      full_name: "Viko RICO",
      first_name: "Viko RICO",
      middle_name: "",
      last_name: "",
      gender: "L",
      birth_place: "Jakarta",
      birth_date: "1978-10-19",
      religion: "Islam",
      ethnicity: "",
      age: 46,
      height_cm: "",
      weight_kg: "",
      phone: "87886999489",
      id_number: "",
      id_region: "",
      living_status: "",
      vehicle_type: "",
      vehicle_ownership: "",
      best_achievement: "",
      best_achievement_desc: "",
      worst_achievement: "",
      worst_achievement_desc: "",
      language_active: "",
      language_passive: "",
      education_sponsor: "",
      scholarship: "",
      scholarship_duration: "",
      scholarship_desc: "",
      influence_source: "",
      influence_note: "",
      publication: "",
      highschool_avg_score: "",
      highschool_subject_count: "",
      gpa: "",
      gpa_max: "",
      modified_by: "P3015",
      modified_at: "2024-08-29 00:00:00",
      active_status: 1,
      employment_status: "Permanent",
      remarks: "",
      seniority_date: "2006-10-02",
      mother_maiden_name: "",
      marital_status: "Married 2 Child",
      marital_date: "0000-00-00",
      marriage_count: 2,
      photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
    },
    
    // Riwayat (History)
    history: {
      last_job_reason_leave: "",
      last_job_salary: "",
      last_job_benefits: "",
      job_most_liked: "",
      job_least_liked: "",
      hobby: "",
      sport: "",
      sport_desc: "",
      free_time: "",
      reading_hours: "",
      reading_topics: "",
      newspaper: "",
      magazine: ""
    },
    
    // Riwayat Pekerjaan (Work History)
    workHistory: [
      // Array of work history objects
    ],
    
    // Aktivitas Sosial (Social Activities)
    socialActivities: [
      // Array of social activity objects
    ],
    
    // Keluarga (Family)
    family: [
      // Array of family member objects
    ],
    
    // Lamaran & Kemampuan (Application & Skills)
    applicationSkills: {
      apply_reason: "",
      apply_initiator: "",
      apply_initiator_note: "",
      desired_position: "",
      expected_salary: "",
      expected_benefits: "",
      skills: "",
      willing_medical: 0,
      willing_psychology: 0,
      willing_relocate: 0,
      willing_trial: 0,
      willing_transfer: 0,
      willing_rules: 0,
      computer_skill: 0,
      computer_programs: "",
      typing_level: "",
      driving_ability: "",
      vehicle_knowledge: 0
    },
    
    // Pendidikan Formal (Formal Education)
    education: [
      {
        level: "S1",
        school_name: "UNIVERSITAS INDONESIA",
        location: "",
        graduation_year: "",
        gpa: "",
        major: "AKUTANSI"
      }
    ],
    
    // Kursus (Courses)
    courses: [
      // Array of course objects
    ],
    
    // Umum & Kesehatan (General & Health)
    generalHealth: {
      willing_original_certificate: 0,
      allow_contact_employer: 0,
      ever_fired: 0,
      decision_advice_source: "",
      decision_advice_note: "",
      personal_advice_source: "",
      personal_advice_note: "",
      reaction_to_criticism: "",
      common_illness: "",
      serious_illness: 0,
      serious_illness_desc: "",
      eye_disease: 0,
      lung_disease: 0,
      ear_disease: 0,
      diabetes: 0,
      hypertension: 0,
      heart_disease: 0,
      last_checkup: "",
      strength: "",
      weakness: ""
    },
    
    // Work Info (existing)
    workInfo: {
      business_unit: "50",
      branch_id: "EUR",
      branch_name: "EUREKA",
      region: "0",
      department: "Kepala cabang",
      position: "AMD EUREKA GROUP",
      organization: "EUREKA",
      composition: "#N/A",
      position_group: "AMD",
      grade: "G10",
      employee_group: "EUREKA",
      education: "S1",
      education_group: "UNIVERSITAS INDONESIA",
      university: "AKUTANSI"
    },
    
    // Address (existing)
    address: {
      street: "Kp. Parung Serab Jl. Tirta Mulya 2 No. 18 Rt. 009/003 Kel. Tirtajaya",
      subdistrict: "",
      rt: "9",
      rw: "3",
      postal_code: "",
      city: "Sukmajaya",
      county: "Depok, Kota",
      province: "Jawa Barat",
      country: "INA",
      location_id: "EUR"
    },
    
    // Benefit (existing)
    benefit: {
      lspsi: 0,
      lkoperasi: 1,
      lsbsi: 0,
      lspn: 0,
      lbpjs_ketenagakerjaan_date: "2006-10-02",
      lbpjs_ketenagakerjaan_no: "7004471806",
      laviva_register_date: "0000-00-00",
      laviva_number: "0",
      lbpjs_kesehatan_date: "0000-00-00",
      lbpjs_kesehatan_no: "0",
      lbumida_date: "0000-00-00",
      lbumida_no: "",
      lbpjs_pensiun_date: "2006-10-02",
      lbpjs_pensiun_no: "7004471806",
      company_insurance_no: "KK120599"
    },
    
    // Contact (existing)
    contact: {
      mobile_phone: "87886999489",
      alt_mobile_phone: "8158874767",
      previous_email: "viko.erl@gmail.com",
      corporate_email: "viko.01@erlangga.co.id"
    },
    
    // Tax (existing)
    tax: {
      tax_category: "K2",
      tax_id: "4,73346E+14",
      payroll_seniority: "2006-10-02",
      salary_scale_date: "0000-00-00",
      year_tax_point_15: "2000",
      year_tax_point_20: "2000"
    },
    
    // Others (existing)
    others: {
      office_type: "Pusat",
      pakta_integritas_2025: 0,
      rahasia_perusahaan_2025: 0,
      update_data_karyawan_2025: "2025",
      penjamin: "",
      update_penjamin_2025: "",
      scan_biodata: 1,
      screening_sdm: 0,
      vehicle_and_facility: 0,
      toll_fee: "0.00",
      distance_km: ""
    },
    
    // Lain-lain (Others/Relations)
    emergency_relations: [
      // Array of emergency contact objects
    ],
    
    former_relations: [
      // Array of former supervisor/family objects  
    ],
    
    guarantors: [
      // Array of guarantor objects
    ]
  },
  {
    id: 2,
    // Data Pribadi (Personal Data) - Complete with candidate fields
    personalData: {
      employee_id: 13,
      employee_code: "P0741",
      full_name: "Siti Nurhaliza",
      first_name: "Siti",
      middle_name: "",
      last_name: "Nurhaliza",
      gender: "P",
      birth_place: "Bandung",
      birth_date: "1985-05-15",
      religion: "Islam",
      ethnicity: "",
      age: 39,
      height_cm: "",
      weight_kg: "",
      phone: "81234567890",
      id_number: "",
      id_region: "",
      living_status: "",
      vehicle_type: "",
      vehicle_ownership: "",
      best_achievement: "",
      best_achievement_desc: "",
      worst_achievement: "",
      worst_achievement_desc: "",
      language_active: "",
      language_passive: "",
      education_sponsor: "",
      scholarship: "",
      scholarship_duration: "",
      scholarship_desc: "",
      influence_source: "",
      influence_note: "",
      publication: "",
      highschool_avg_score: "",
      highschool_subject_count: "",
      gpa: "",
      gpa_max: "",
      modified_by: "P3015",
      modified_at: "2024-08-29 00:00:00",
      active_status: 1,
      employment_status: "Permanent",
      remarks: "",
      seniority_date: "2010-03-15",
      mother_maiden_name: "Sari",
      marital_status: "Single",
      marital_date: "0000-00-00",
      marriage_count: 0,
      photo: "https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face"
    },
    
    // Riwayat (History)
    history: {
      last_job_reason_leave: "",
      last_job_salary: "",
      last_job_benefits: "",
      job_most_liked: "",
      job_least_liked: "",
      hobby: "",
      sport: "",
      sport_desc: "",
      free_time: "",
      reading_hours: "",
      reading_topics: "",
      newspaper: "",
      magazine: ""
    },
    
    // Riwayat Pekerjaan (Work History)
    workHistory: [],
    
    // Aktivitas Sosial (Social Activities)
    socialActivities: [],
    
    // Keluarga (Family)
    family: [],
    
    // Lamaran & Kemampuan (Application & Skills)
    applicationSkills: {
      apply_reason: "",
      apply_initiator: "",
      apply_initiator_note: "",
      desired_position: "",
      expected_salary: "",
      expected_benefits: "",
      skills: "",
      willing_medical: 0,
      willing_psychology: 0,
      willing_relocate: 0,
      willing_trial: 0,
      willing_transfer: 0,
      willing_rules: 0,
      computer_skill: 0,
      computer_programs: "",
      typing_level: "",
      driving_ability: "",
      vehicle_knowledge: 0
    },
    
    // Pendidikan Formal (Formal Education)
    education: [
      {
        level: "S1",
        school_name: "UNIVERSITAS PADJADJARAN",
        location: "",
        graduation_year: "",
        gpa: "",
        major: "PSIKOLOGI"
      }
    ],
    
    // Kursus (Courses)
    courses: [],
    
    // Umum & Kesehatan (General & Health)
    generalHealth: {
      willing_original_certificate: 0,
      allow_contact_employer: 0,
      ever_fired: 0,
      decision_advice_source: "",
      decision_advice_note: "",
      personal_advice_source: "",
      personal_advice_note: "",
      reaction_to_criticism: "",
      common_illness: "",
      serious_illness: 0,
      serious_illness_desc: "",
      eye_disease: 0,
      lung_disease: 0,
      ear_disease: 0,
      diabetes: 0,
      hypertension: 0,
      heart_disease: 0,
      last_checkup: "",
      strength: "",
      weakness: ""
    },
    
    // Work Info (existing)
    workInfo: {
      business_unit: "51",
      branch_id: "EUR",
      branch_name: "EUREKA",
      region: "1",
      department: "Human Resources",
      position: "HR Manager",
      organization: "EUREKA",
      composition: "#N/A",
      position_group: "Manager",
      grade: "G8",
      employee_group: "EUREKA",
      education: "S1",
      education_group: "UNIVERSITAS PADJADJARAN",
      university: "PSIKOLOGI"
    },
    
    // Address (existing)
    address: {
      street: "Jl. Cihampelas No. 45 Rt. 005/002 Kel. Cipaganti",
      subdistrict: "Coblong",
      rt: "5",
      rw: "2",
      postal_code: "40131",
      city: "Bandung",
      county: "Bandung, Kota",
      province: "Jawa Barat",
      country: "INA",
      location_id: "EUR"
    },
    
    // Benefit (existing)
    benefit: {
      lspsi: 1,
      lkoperasi: 1,
      lsbsi: 1,
      lspn: 0,
      lbpjs_ketenagakerjaan_date: "2010-03-15",
      lbpjs_ketenagakerjaan_no: "7004471807",
      laviva_register_date: "2010-03-15",
      laviva_number: "AV001234",
      lbpjs_kesehatan_date: "2010-03-15",
      lbpjs_kesehatan_no: "0001234567890",
      lbumida_date: "2010-03-15",
      lbumida_no: "UM001234",
      lbpjs_pensiun_date: "2010-03-15",
      lbpjs_pensiun_no: "7004471807",
      company_insurance_no: "KK120600"
    },
    
    // Contact (existing)
    contact: {
      mobile_phone: "81234567890",
      alt_mobile_phone: "87654321098",
      previous_email: "siti.nurhaliza@gmail.com",
      corporate_email: "siti.nurhaliza@erlangga.co.id"
    },
    
    // Tax (existing)
    tax: {
      tax_category: "TK0",
      tax_id: "1,23456E+14",
      payroll_seniority: "2010-03-15",
      salary_scale_date: "2024-01-01",
      year_tax_point_15: "1500",
      year_tax_point_20: "1800"
    },
    
    // Others (existing)
    others: {
      office_type: "Cabang",
      pakta_integritas_2025: 1,
      rahasia_perusahaan_2025: 1,
      update_data_karyawan_2025: "2025",
      penjamin: "Ahmad Wijaya",
      update_penjamin_2025: "2025",
      scan_biodata: 1,
      screening_sdm: 1,
      vehicle_and_facility: 1,
      toll_fee: "150000.00",
      distance_km: "25"
    },
    
    // Lain-lain (Others/Relations)
    emergency_relations: [],
    former_relations: [],
    guarantors: []
  }
];

export default employeesData;